<template>
	<div>
		<div class="card">
			<div class="card__header">
				<h4 class="card__title">Кредит</h4>
			</div>
			<div class="card__body">
				<nav class="fields__item nav-line">
					<router-link :to="{name: 'revshare'}" class="nav-line__item">RevShare</router-link>
					<router-link :to="{name: 'promocodes'}" class="nav-line__item">Промокоды</router-link>
					<router-link
						v-if="user && (user.is_admin || user.can_transfer)"
						:to="{name: 'transfer'}" class="nav-line__item">
						Переводы
					</router-link>
					<a class="nav-line__item active"
					   v-if="user && (user.is_admin || user.max_loan)">
						Кредит
					</a>
				</nav>

				<div class="fields__item">
					<div class="fields__row">
						<div class="fields__col">
							<div class="fields__item">
								<div class="text-field__label">Максимальная доступная сумма кредита <strong>{{ data.free_loan_amount }}</strong> ₽ под <strong>{{ data.commission }}</strong>%</div>
								<input v-model="data.amount" class="text-field__input" type="text" placeholder="Сумма">
							</div>
							<button
								@click="take()"
								:disabled="disableButton"
								type="submit" class="btn btn--primary">
								Взять кредит
							</button>
						</div>
						<div class="fields__col">
							<div class="table-wrap" v-if="Object.keys(loans).length">
								<table class="table table--bordered text-center">
									<thead>
									<tr>
										<th>Сумма</th>
										<th>Долг</th>
										<th>Закрыто</th>
										<th>Дата</th>
									</tr>
									</thead>
									<tbody>
									<tr v-for="(loan) in loans">
										<td>
											{{ Number(loan.amount).toFixed(2) }} ₽
										</td>
										<td>
											{{ Number(loan.total).toFixed(2) }} ₽
										</td>
										<td>
											{{ Number(loan.covered).toFixed(2) }} ₽
										</td>
										<td>
											{{ loan.datetime }}
										</td>
									</tr>
									</tbody>
								</table>
							</div>
							<div class="text-center" v-else>
								<h4>У вас нету открытых кредитов</h4>
							</div>
						</div>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
import { mapState } from 'pinia';
import { useUserStore } from '../../stores/User';

export default {
	data() {
		return {
			loans: [],
			data: {
				amount: '',
				commission: 0,
				max_loan: 0,
				current_loan_amount: 0,
				free_loan_amount: 0
			},
			isValid: true,
			disableButton: false
		}
	},
	mounted() {
		this.$root.isLoading = true;

		if(!this.$cookie.get('token')) {
			this.$root.isLoading = false;
			this.$router.go(-1);
		}

		this.get();
	},
	computed: {
		...mapState(useUserStore, ['user'])
	},
	methods: {
		validate() {
			this.isValid = true;
			this.disableButton = true;
			this.data.amount = Number(this.data.amount).toFixed(2);

			if(isNaN(this.data.amount) || this.data.amount > this.data.free_loan_amount) {
				this.isValid = false;
				this.$toast.error('Введите сумму не более ' + this.data.free_loan_amount);
			}

			this.disableButton = false;

			return this.isValid;
		},
		get() {
			this.$root.axios.get('/api/loans')
				.then(res => {
					this.loans = res.data.loans;

					this.data.current_loan_amount = res.data.current_loan_amount;
					this.data.free_loan_amount = res.data.free_loan_amount;
					this.data.max_loan = res.data.max_loan;
					this.data.commission = res.data.loan_commission;

					this.$root.isLoading = false;
				})
		},
		take() {
			if(!this.validate()) return;

			this.$root.axios.post('/api/loans/take', this.data)
				.then(res => {
					this.$toast.success(res.data.message);
					this.user.balance = res.data.balance;

					this.get();
				}).catch(error => {
				this.$toast.error(this.$root.graphql.axiosGetError(error));
			});
		},
	}
}
</script>
